<template>
  <tci-recruit subtitle="PROJECT DEVELOPMENT LEADER" :title="$t('recruit.mainPage.recruit_manager')" :recruits="infos"></tci-recruit>
</template>

<script>
import TciRecruit from "@/components/TciRecruit.vue";

export default {
  name: "RecruitManager",
  components: {
    "tci-recruit": TciRecruit
  },
  data: () => ({
    infos: [{"name":"项目开发负责人", "position":"苏州","email":"suzhou@trans-cosmos.com.cn","requests":[
      "大专及以上学历，计算机相关专业，3年以上开发经验，1年以上项目管理经验。",
      "具备Java,.NET,php,cobol其中一门语言相关开发知识和经验。",
      "熟悉B/S和C/S架构，拥有熟练的C#、php、.Net、JavaScript、Html等开发技术。",
      "具有良好规范的文档和编程习惯。",
      "熟悉MYSQL、SQL server或Oracle数据库分析与设计。",
      "具有良好的计划和执行能力、组织协调能力及人际沟通能力，善于分析解决问题，有责任心，有团队精神。",
      "有日语基础者优先考虑。"
    ],"responses":[
      "项目管理：制定项目计划与流程，安排开发人员工作，协调项目实施与验收，推进项目顺利交付上线。",
      "承担主要技术调研工作和技术提案，积极主动帮助辅导下属工作。",
      "对生产型的工厂业务有一定了解。"
    ]}
    ]
  })
};
</script>
